<template>
	<div>
		<div class="px-0 mt-5"> 
			<div class="row">
				
				
				<div class="row col-12 no-margin px-0">
					<div class="ibox col-md-12">
						<div class="ibox-title dashboard_title">
							<h4 class="clearfix">
								<span class="float-left">Overview</span>
								<span class="float-right">Joining Date: {{this.public_info.date_of_joining}}</span>
							</h4>
						</div>
						<div class="ibox-content">
							<template  v-if="employee_info.length == 0">
									<div class="no-result-cell text-center">
										<img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo pf-dashboard-overview-loader"/>
									</div>
							</template>
							<template v-else>
								<div class="row">
									<div class="col-lg-3 col-md-6 col-sm-12 cursor-pointer">
										<div class="shortcut-button">
											<span>
												<h3>
													Membership Date
												</h3>
												<span>{{ employee_info.PF_enrollment_date }}</span>
											</span>
										</div>
									</div>
									<div class="col-lg-3 col-md-6 col-sm-12 cursor-pointer">
										<div class="shortcut-button">
											<span>
												<h3>
													Membership Period
												</h3>
												<span>{{ employee_info.PF_membership_period }}</span>
											</span>
										</div>
									</div>
									<div class="col-lg-3 col-md-6 col-sm-12 cursor-pointer">
										<div class="shortcut-button">
											<span>
												<h3>
													PF Balance
												</h3>
												<template v-if="details.loan_balance != undefined">
													<span>{{ formatMoney(details.closing_balance) }}</span>
												</template>
		
												
											</span>
										</div>
									</div>
									<div class="col-lg-3 col-md-6 col-sm-12 cursor-pointer">
										<div class="shortcut-button">
											<span>
												<h3>
													PF Advance Balance
												</h3>
												<template v-if="details.loan_balance != undefined">
													<span>{{ formatMoney(details.loan_balance) }}</span>
												</template>
								
												
											</span>
										</div>
									</div>
								</div>
							</template>
							
						</div>
					</div>
					<div class="ibox col-md-12 border-0">
						<div class="ibox-title dashboard_title">
							<h4 class="clearfix">
								<span class="float-left">Provident Fund Summary<span class="title-sub-text">A comprehensive overview of an employee's contributions and balance in their provident fund account.</span></span>
								<span class="float-right">
									<select id="year" v-model="year" name="year" class="form-control custom-select" v-on:change="setfiscalyear()">
										<template v-if="pf_settings.pf_year_end.opt_value != 12">
											<option v-for='pyr in payrunyears'  :value='pyr'>{{ pyr }}</option>		
										</template>	
										<template v-else>
											<option v-for='pyr in f_y'  :value='pyr'>{{ pyr }}</option>		
										</template>
									</select> 
								</span>
							</h4>
						</div>
						<div class="ibox-content">
							<template  v-if="pf_statement_data.length == 0">
									<div class="no-result-cell text-center">
										<img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo pf-dashboard-summery-loader"/>
									</div>
							</template>
							<template v-else>
								<div class="row">
									<div class="col-lg-12 col-md-12 col-sm-12 cursor-pointer">
										<table class="w-100">
											<thead>
												<tr class="table-head">
													<th scope="col">Particulars</th>
													<th class="text-right" scope="col">Member’s Amount (BDT)</th>
													<th class="text-right" scope="col">Company’s Amount (BDT)*</th>
													<th class="text-right" scope="col">Total Amount (BDT)</th>
												</tr>
											</thead>
											<tbody>
												<template v-if="show_data">
													<tr class="table-row">
														<td class="font-semi-bold">{{ pf_statement_data.opening_text }}</td>
														<td class="text-right font-semi-bold">{{ formatMoney(pf_statement_data.employee.opening) }}</td>
														<td class="text-right font-semi-bold">{{ formatMoney(pf_statement_data.employer.opening) }}</td> 
														<td class="text-right font-semi-bold">{{ formatMoney(pf_statement_data.opening_total) }}</td>
													</tr>
													<tr class="table-row">
														<td>{{ pf_statement_data.contribution_text }}</td>
														<td class="text-right">{{ formatMoney(pf_statement_data.employee.contribution) }}</td>
														<td class="text-right">{{ formatMoney(pf_statement_data.employer.contribution) }}</td>
														<td class="text-right">{{ formatMoney(pf_statement_data.contribution_total) }}</td>
													</tr>
													<tr class="table-row">
														<td>Add: Interest/profit accrued during the year</td>
														<td class="text-right">{{ formatMoney(pf_statement_data.employee.profit) }}</td>
														<td class="text-right">{{ formatMoney(pf_statement_data.employer.profit) }}</td>
														<td class="text-right">{{ formatMoney(pf_statement_data.profit_total) }}</td>
													</tr>
													<tr class="table-row">
														<td>Less: PF Advance Balance</td>
														<td class="text-right">({{ formatMoney(pf_statement_data.employee.loan) }})</td>
														<td class="text-right">({{ formatMoney(pf_statement_data.employer.loan) }})</td>
														<td class="text-right">({{ formatMoney(pf_statement_data.loan_total) }})</td>
													</tr>
													<tr class="table-row">
														<td class="font-semi-bold">{{ pf_statement_data.closing_text }}</td>
														<td class="text-right font-semi-bold">{{ formatMoney(pf_statement_data.employee.closing) }}</td>
														<td class="text-right font-semi-bold">{{ formatMoney(pf_statement_data.employer.closing) }}</td>
														<td class="text-right font-semi-bold">{{ formatMoney(pf_statement_data.closing_total) }}</td>
													</tr>
												</template>
												
																			
											</tbody>
										</table>
									</div>
								</div>
							</template>
							
						</div>
					</div>
					
				</div>
			
			</div>
		</div>
		
	</div>
</template>
<script> 
  
    import moment from 'moment';
    export default{
      mounted() {
            this.$refs.trzcalendar;
        },

        props: ['pageurl'],
        components: {
        },
        data(){

            return {
               activateKey: 0,
               pageUrl : this.$api_url,
			   showoverlay_h:true,
			   show_data:false,
               public_info : [],
               avatarsrc : '',
               avatarsrc1 : '',                
               company_avatarsrc1 : '',      
               img_src : this.$api_url+'/images/employee_dasboard/', 
               cr : 0, 
               this_month : 1,
               this_year : 2020,
               weekly_holidays : [6],
               first_day_of_week : 7,
               this_month_holidays : [],
               week_holidays : [6],
               all_week_holidays : [6],
               holidays_date_arr : [],
			   report_data:[],
			   employee_info:[],
			   details:[],
               header_year_month : '',
               start_date: null,
               end_date: null,
               total_working_day : 0,
               total_weekends : 0,
               total_holidays : 0,
               total_absent : 0,
               total_leaves : 0,
               page: { month: '', year: '' }, 
			   company_access_settings:{},  
			   payrunyears: [], 
			   pf_statement_data:[],
			   year: '', 
			   f_y:[],
			   pf_settings :{pf_profit_waive_feature:{ opt_value: 0, status: 0 },pf_year_end:{ opt_value: 0, status: 0 },},

			   attributes: [
					{
						key: 'today',
						highlight: {
							style: {                     // Circle styles
								background: '#5533FF'
							},
							contentStyle: {              // Text styles
								color: 'white'
							},
							contentClass: 'date-text-today',
							class: 'date-circle-today',
						},
						dates: new Date(),
					}
				],
            }
        },
        methods:{
            monthDetails: function(x='' , y=0, m=0)
            {                
               let currentObj = this;
               let year = 0;
               let month = 0;
               
               if(y == 0)    
               {
                  year = x['year'];
                  month = x['month'];
               }   
               else
               {
                  year = y;
                  month = m;
               }     
                  
               let st_date = new Date(year , month - 1 , 1);
               let en_date = new Date(year , month , 0);   

               
               this.start_date = moment(String(st_date)).format('Do MMMM YYYY');
               this.end_date = moment(String(en_date)).format('Do MMMM YYYY');
               
            

                  // fetch holidays dynamically from controller
            
            },
            updateActivityLog: function(data)
            {
               this.activateKey = this.activateKey+1;
               
            },

            getEmployeeActiveYearlist:function(employee_id)
            {        
                 
                if(!this.checkNet()) return false;

				let formData = new FormData();
                
                formData.append('employee_id', employee_id);

                //currentObj.showoverlay = true;
                
                axios.post(this.$api_url + '/pf/employee/active-year-list', formData)
				.then(function (response) 
				{
                        this.respData = response.data;
                        
                        if(this.respData.fiscal_year.length > 0) 
                        {
                            this.payrunyears = this.respData.fiscal_year;
                            this.f_y = this.respData.year;

							if(this.pf_settings.pf_year_end.opt_value != 12)
							{
								this.year= this.payrunyears[0];
							}
							else
							{
								this.year= this.f_y[0];
							}
							this.getPFStatement(this.year);
							
							
                        }
                        else
                        {
                            
                        }
                        
                        
                    }.bind(this)).catch(function (error){alert(error)});

               
               
            }, 
            getEmployeePublicData: function()
            {
               if(!this.checkNet()) return false;
               axios.get(this.$api_url+'/employee/publicinfo' , {
                  params: {
                     
                  }
               }).then(function(response){
                  if(response.data)
                  {
                     this.company_assigned = true;
                     this.public_info = response.data;
                     

                     if(this.public_info.pic != '')
                           this.avatarsrc = this.$api_url+'/images/employee/'+ this.public_info.company_id + '/' + this.public_info.pic;
                     else
                           this.avatarsrc = this.$api_url+'/images/employee/demo.jpg';
                     if(this.public_info.logo != '')//at_edit
                           this.company_avatarsrc1 = this.$api_url+'/images/company/' + this.public_info.logo;//at_edit
                     else
                           this.company_avatarsrc1 = this.$api_url+'/images/company/demo.jpg';

                     if(this.public_info.report_to_pic != '')
                           this.avatarsrc1 = this.$api_url+'/images/employee/'+ this.public_info.company_id + '/' + this.public_info.logo; //at_edit
                     else
                           this.avatarsrc1 = this.$api_url+'/images/employee/demo.jpg';

                  }
                  else
                  {
                     this.company_assigned = false;
                     this.no_company_message = 'As soon as you are associated with any company, you will be able to see all data accordingly!';
                  }

                  
                  
               }.bind(this));
         	},
			setMe :function(x)
			{
				
				
				if(x == 'request-leave')            
				this.$bvModal.show('bv-modal-leave');
				else
				{
				
				let childdata = {component_name:x};                    
				this.$emit('childToParent', childdata);
				}
				
			},
			reloadMe : function()
			{
				this.$bvModal.hide('bv-modal-leave');
			},
		 	get_access_settings: function()
            {
                // 
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/employee-access-settings' , {
                }).then(function(response){

                    let company_access_settings_temp = {};
                    company_access_settings_temp = response.data;
                    
                    for (const [key, value] of Object.entries(company_access_settings_temp)) {
                        
                            if(value==1)
                            {
                                company_access_settings_temp[key] = true;
                            }
                            else
                            {
                                company_access_settings_temp[key] = false;
                            }

                            }

                    this.company_access_settings = company_access_settings_temp;

                }.bind(this));
            },

			getpayrunyears: function()
			{

						axios.get(this.$api_url+'/getpayrun-years' , {
							params: {
								page: 1,
								per_page: 10,
								search_query: this.search,
								search_query_by_id: '',
							}
					}).then(function(response){
					this.payrunyears = response.data;
					
					console.log(this.payrunyears[0].range);


				}.bind(this));
			},
			get_current_fiscal_year: function()
            {
                // 
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/getcurrentfiscalyear' , {
                }).then(function(response){
                    this.year= response.data;
                    
                }.bind(this));
            },
			setfiscalyear: function()
			{
				this.getPFStatement(this.year);
			},
			getPFStatement: function(year)
			{
				let currentObj = this;
				let formData = new FormData();
				formData.append('employee_id', this.employee_info.employee_id);
				formData.append('fiscal_year', year);
				formData.append('modification_flag',14);

				//currentObj.download_loader = true;

				axios.post(this.$api_url+'/pf/report/statement', formData)
				.then(function (response) {                            
											
						currentObj.showoverlay_h = false;
						currentObj.pf_statement_data = response.data;
						currentObj.show_data = true;
						
						// currentObj.download_loader = false;  
						// currentObj.download_text = ''; 
						
					})
					.catch(function (error) {
						// currentObj.output = error;
						// currentObj.download_loader = false;
						// currentObj.showoverlay_h = false;
						
						// currentObj.download_text = '';
					});
                    
			
			},
			pfDetailsNew: function()
            { 
                
                let currentObj = this;
                
                let formData = new FormData();
                
                formData.append('viewmode', 1);
                formData.append('d_type', 'excel'); 
                formData.append('data_front', 'yes'); 
                this.pfoverlay = true;
                this.report_data = [];
                this.details = [];
                this.employee_info = [];

                //currentObj.showoverlay = true;
                
                axios.post(this.$api_url + '/pf/report/profile', formData)
                                    .then(function (response) 
                                    {
                                        
                                        this.employee_info = response.data.file_name.employee_info;
                                        this.details = response.data.file_name.data;
										// alert('asd');
                                        // console.log(this.employee_info);
                                        // console.log(this.details);
                                        //currentObj.showoverlay = false;
                                        this.pfoverlay = true;
										this.getEmployeeActiveYearlist(this.employee_info.employee_id); 
										this.getPFStatement(this.year);
                                    }.bind(this))
                                    .catch(function (error) 
                                    {
                                        //currentObj.showoverlay = false;
                                        console.log(error);
                                    }); 

                    

                    this.$bvModal.show('bv-modal-pf-details');

            }, 
			// Start: Rejwan: 24-04-2025 2 decimal
			// formatMoney: function(amount)
            // {
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }
                
            //     return money;
            // }, 
           toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, ''); 
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return amount;
            },
			getPFSettings: function()
			{ 
				
				let currentObj = this;
				axios.get(this.$api_url+'/pf/settings').then(function (response) {
					currentObj.pf_settings = response.data.data;
				
						
				})  
				.catch(function (error) {
				console.log(error);
				});
				
			},
            
            
        },
        created: function(){
			this.pfDetailsNew();
			this.getPFSettings();
            this.getEmployeePublicData();
			this.get_access_settings();
			//this.getpayrunyears();
			this.get_current_fiscal_year();
            // var m = check.format('M');
            // var y  = check.format('YYYY');
            // this.monthDetails('',y,m);
            // this.page = { month: m, year: y };
         
        },
 
    }

</script>
